"use client";

import styles from "./TicketsPurchase.module.css";
import { useInView } from "react-intersection-observer";
import WavePurchase from "../WavePurchase/WavePurchase";
import Checkout from "../../Checkout/Checkout";
import { useTicketHandler } from "../../../hooks/useTicketHandler";
import { useState, useEffect, useRef, useMemo } from "react";
import SmallCart from "../../SmallCart/SmallCart";
import { BsFillArrowDownCircleFill } from "react-icons/bs";
import Cookies from "js-cookie";

// Main ticket purchase component
const TicketsPurchase = ({
  tickets = [],
  eventID,
  gateway,
  event,
  groups = [],
  utm_source = "",
  handleOpenCloseSeating,
  hideGroup = false,
  handleOpenPolicy
}) => {
  const ticketRef = useRef(null); // Create a ref for the #tickets section
  // useEffect(() => {
  //   groups.forEach((obj) => {
  //     obj.creationDate = new Date(obj.createdAt._seconds * 1000); // Multiply by 1000 to convert to milliseconds
  //   });
  //   // console.log(groups);
  //   // Sort the array by creation date in ascending order
  //   groups.sort((a, b) => a.creationDate - b.creationDate);
  // }, []);
  /// Group
  // Selected Group
  let groupsFirst = event.groupsFirst ?? true;
  const [selectedGroup, setSelectedGroup] = useState(null);
  const handleGroupClick = (group) => {
    setSelectedGroup(selectedGroup === group ? null : group);
  };

  const mergedTickets = useMemo(() => {
    if (selectedGroup) {
      return selectedGroup.tickets;
    }
    return [...tickets, ...groups.flatMap((group) => group.tickets)];
  }, [tickets, groups, selectedGroup]);

  /// End group
  useEffect(() => {
    // Check if the URL hash is '#tickets', if the ticketRef is set, and if there are any tickets
    if (
      window.location.hash === "#tickets" &&
      ticketRef.current &&
      tickets.length > 0
    ) {
      ticketRef.current.scrollIntoView({ behavior: "smooth" }); // Scroll to the #tickets section
    }
  }, [ticketRef.current, tickets]); // Run this effect every time ticketRef.current or tickets changes

  // console.log(event);
  // Use ticket handler hook to provide state management and handlers
  const {
    waveStates,
    selectedItems,
    quantities,
    handleTicketClick,
    handleQuantityChange,
    handleIncrement,
    handleDecrement,
    handleContinueAsGuest,
  } = useTicketHandler(mergedTickets, eventID);

  // useEffect(() => {
  //   // Loop through the groups
  //   groups.forEach((group) => {
  //     // Loop through the tickets in each group
  //     group.tickets.forEach((ticket) => {
  //       // If selectedItems includes the ticket, open the group
  //       if (selectedItems.some((item) => item.ticketID === ticket.ticketID)) {
  //         setSelectedGroup(group);
  //       }
  //     });
  //     group.tickets.forEach((obj) => {
  //       obj.creationDate = new Date(obj.createdAt._seconds * 1000); // Multiply by 1000 to convert to milliseconds
  //     });
  //     // Sort the array by creation date in ascending order
  //     group.tickets.sort((a, b) => a.creationDate - b.creationDate);
  //   });
  // }, [selectedItems, groups]);

  // Calculate total quantity of all tickets
  //    const selected = Cookies.get("testItems");
  
  // const getInitialSelectedItem = (selected) => {
  //   try {
  //     return selected ? JSON.parse(selected) : null;
  //   } catch (error) {
  //     console.error("Error parsing selected:", error);
  //     return null;
  //   }
  // };
  
  // const [selectedItem, setSelectedItem] = useState(
  //   getInitialSelectedItem(selected)
  // );
  
  // useEffect(() => {
  //   if (selected) {
  //     try {
  //       setSelectedItem(JSON.parse(selected));
  //     } catch (e) {
  //       console.error("Failed to parse selected:", e);
  //     }
  //   }
  // }, [selected]);
  
  const totalQuantity = Object.values(quantities).reduce((a, b) => a + b, 0);
  // const totalQuantity = selectedItem?.quantity??0;
  console.log("Total Quantity:", totalQuantity);
  
  // States for checkout open and cart visibility
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [isCartVisible, setIsCartVisible] = useState(false);

  // Observer for the checkout section
  const [checkoutRef, checkoutInView] = useInView({
    triggerOnce: false,
    threshold: 0.01,
  });

  // Handler for the cart click - scrolls to tickets and opens checkout
  const handleCartClick = () => {
    document.getElementById("tickets").scrollIntoView();
    setIsCheckoutOpen(true);
  };

  const updateIsCheckoutOpen = (value) => {
    setIsCheckoutOpen(value);
  };

  const updateIsCartVisible = (value) => {
    setIsCartVisible(value);
  };

  // Effect to set checkout open state depending on if there are selected items
  useEffect(() => {
    updateIsCheckoutOpen(totalQuantity > 0);
  }, [totalQuantity]);

  // Effect to handle visibility of the cart depending on checkout in view
  useEffect(() => {
    if (!checkoutInView && window.innerWidth > 750) {
      updateIsCartVisible(true);
    } else {
      updateIsCartVisible(false);
    }
  }, [checkoutInView]);

  // Function to render the wave purchase component
  const renderWavePurchase = (ticket, type) =>{ 

    // console.log(ticket);
  return  <WavePurchase
      key={ticket.ticketID}
      waves={ticket.sales}
      currency={ticket.currency}
      maxPerOrder={ticket.sales[0].maxPerOrder}
      onQuantityChange={handleQuantityChange}
      quantities={quantities}
      handleIncrement={handleIncrement}
      handleDecrement={handleDecrement}
      name={ticket.name}
      ticket={ticket}
      event={event}
      type={type}
      handleOpenCloseSeating={handleOpenCloseSeating}
      minPerOrder={ticket.sales[0].minPerOrder}
    />
  };
  // console.log(tickets);
  // console.log("tickets");
  // console.log(groups);
  // Function to render the checkout component
  const renderCheckout = (ticket) =>{
    console.log(ticket);
    
  return  isCheckoutOpen &&
    selectedItems.length > 0 && (
      <div ref={checkoutRef}>
        <Checkout
          eventID={eventID}
          selectedItems={selectedItems}
          currency={ticket.currency}
          maxPerOrder={ticket.maxPerOrder}
          absorbFees={ticket.absorbFees}
          quantities={quantities}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          isInView={checkoutInView}
          ticket={ticket}
          gateway={gateway}
          event={event}
          handleContinueAsGuest={handleContinueAsGuest}
          utm_source={utm_source}
          minPerOrder={ticket.minPerOrder}
          handleOpenPolicy={handleOpenPolicy}
        />
      </div>
  
    );
  };
  // console.log(event);
  // Main render function
  return (
    <div className={styles.wrapper} id="tickets" ref={ticketRef}>
      <h2>
        {event.orgID === "hGTSDyBIbQkKfglL18gk" ? "Entry Options" : "TICKETS"}
      </h2>
      <div className={styles.row}>
        <div className={styles.column}>
          {groupsFirst ? (
            <>
              {groups.length > 0 && !hideGroup && (
                <div className={styles.tickets_group_big}>
                  {" "}
                  <div className={styles.column_group}>
                    {groups.map((group, i) => (
                      <div key={i} className={styles.groupItem}>
                        <div
                          className={styles.row_group}
                          onClick={() => handleGroupClick(group)}
                        >
                          <span> {group.name}</span>
                          <BsFillArrowDownCircleFill
                            className={`
                    ${styles.icon_group} 
                    ${selectedGroup === group && styles.rotate}
                  `}
                          />
                        </div>
                        {selectedGroup === group && (
                          <div className={styles.tickets_group}>
                            {group.tickets.map((ticket, i) => (
                              <div key={i} className={styles.ticket_wrap_group}>
                                <div className={styles.ticketContainer_group}>
                                  {ticket.sales.length > 1 && (
                                    <div
                                      className={styles.ticket_group}
                                      onClick={() =>
                                        handleTicketClick(ticket.ticketID)
                                      }
                                    >
                                      <span>{ticket.name}</span>
                                    </div>
                                  )}
                                  {(ticket.sales.length === 1 ||
                                    waveStates[ticket.ticketID]) &&
                                    renderWavePurchase(ticket, "group")}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className={styles.tickets}>
                {tickets.map((ticket) => (
                  <div key={ticket.ticketID} className={styles.ticket_wrap}>
                    <div className={styles.ticketContainer}>
                      {ticket.sales.length > 1 && (
                        <div
                          className={styles.ticket}
                          onClick={() => handleTicketClick(ticket.ticketID)}
                        >
                          <span>{ticket.name}</span>
                          <BsFillArrowDownCircleFill
                            className={`
                           ${styles.icon_group} 
                           ${waveStates[ticket.ticketID] && styles.rotate}
                         `}
                          />
                        </div>
                      )}

                      {(ticket.sales.length === 1 ||
                        waveStates[ticket.ticketID]) &&
                        renderWavePurchase(ticket, "single")}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className={styles.tickets}>
                {tickets.map((ticket) => (
                  <div key={ticket.ticketID} className={styles.ticket_wrap}>
                    <div className={styles.ticketContainer}>
                      {ticket.sales.length > 1 && (
                        <div
                          className={styles.ticket}
                          onClick={() => handleTicketClick(ticket.ticketID)}
                        >
                          <span>{ticket.name}</span>
                        </div>
                      )}
                      {(ticket.sales.length === 1 ||
                        waveStates[ticket.ticketID]) &&
                        renderWavePurchase(ticket, "single")}
                    </div>
                  </div>
                ))}
              </div>
              {groups.length > 0 && (
                <div className={styles.tickets_group_big}>
                  {" "}
                  <div className={styles.column_group}>
                    {groups.map((group, i) => (
                      <div key={i} className={styles.groupItem}>
                        <div
                          className={styles.row_group}
                          onClick={() => handleGroupClick(group)}
                        >
                          <span> {group.name}</span>
                          <BsFillArrowDownCircleFill
                            className={`
                    ${styles.icon_group} 
                    ${selectedGroup === group && styles.rotate}
                  `}
                          />
                        </div>
                        {selectedGroup === group && (
                          <div className={styles.tickets_group}>
                            {group.tickets.map((ticket, i) => (
                              <div key={i} className={styles.ticket_wrap_group}>
                                <div className={styles.ticketContainer_group}>
                                  {ticket.sales.length > 1 && (
                                    <div
                                      className={styles.ticket_group}
                                      onClick={() =>
                                        handleTicketClick(ticket.ticketID)
                                      }
                                    >
                                      <span>{ticket.name}</span>
                                    </div>
                                  )}
                                  {(ticket.sales.length === 1 ||
                                    waveStates[ticket.ticketID]) &&
                                    renderWavePurchase(ticket, "group")}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div>
          {selectedItems.length > 0 && renderCheckout(selectedItems[0])}
          {isCartVisible && (
            <SmallCart
              totalQuantity={totalQuantity}
              onCartClick={handleCartClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketsPurchase;
